import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles scroll behavior on client-side route changes.
 * - If the URL has a hash, scroll that element into view (after it has mounted).
 * - Otherwise, scroll to the top of the page on every pathname change.
 * React Router does neither of these by default.
 */
export default function ScrollManager() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.slice(1);
            // Retry a few times because the target may not be in the DOM yet
            // (dynamic sections mount after initial render).
            let attempts = 0;
            const tryScroll = () => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                } else if (attempts < 10) {
                    attempts += 1;
                    setTimeout(tryScroll, 80);
                }
            };
            tryScroll();
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
    }, [pathname, hash]);

    return null;
}
